import { createContext, use } from 'react';

export type ToastVariant = 'error' | 'warning' | 'success' | 'info';

export interface ToastData {
  id: string;
  variant: ToastVariant;
  title: string;
  description?: string;
  /**
   * Optional inline action button. When present, renders a text button inside
   * the toast body. Clicking it invokes the handler and then dismisses the toast.
   * Optional - existing toasts that omit this field render unchanged.
   */
  action?: { label: string; onClick: () => void };
  /** ms – 0 means sticky (manual dismiss only) */
  duration: number;
}

export type AddToastInput = Omit<ToastData, 'id' | 'duration'> & { duration?: number };

export interface ToastContextValue {
  addToast: (toast: AddToastInput) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const ctx = use(ToastContext);
  if (!ctx) throw new Error('useToast must be used within <ToastProvider>');
  return ctx;
}
